import { render, staticRenderFns } from "./CreateSegment.vue?vue&type=template&id=69c4ec72"
import script from "./CreateSegment.vue?vue&type=script&lang=js"
export * from "./CreateSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports